var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerbi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "150px",
    height: "150px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,1c-1.378,0 -2.5,1.122 -2.5,2.5v6.5h6.5c2.481,0 4.5,2.019 4.5,4.5v34.5h4.5c1.378,0 2.5,-1.121 2.5,-2.5v-43c0,-1.378 -1.122,-2.5 -2.5,-2.5zM18.5,12c-1.378,0 -2.5,1.122 -2.5,2.5v5.5h6.5c2.481,0 4.5,2.019 4.5,4.5v24.5h4.5c1.378,0 2.5,-1.121 2.5,-2.5v-32c0,-1.378 -1.122,-2.5 -2.5,-2.5zM9.5,22c-1.378,0 -2.5,1.122 -2.5,2.5v22c0,1.379 1.122,2.5 2.5,2.5h13c1.378,0 2.5,-1.121 2.5,-2.5v-22c0,-1.378 -1.122,-2.5 -2.5,-2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbi);
export default __webpack_public_path__ + "static/media/powerbi.fa5202eaffd720146c2dcbf912198fb9.svg";
export { ForwardRef as ReactComponent };